import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9004Handlers = [
	http.post(PlessService.SERVICE.getFunctionList.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(getFunctionList);
			// return ResponseUtils.getSysError();
		}
	),
  http.post(PlessService.SERVICE.getAuthoritySetDetail.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(getAuthoritySetDetail);
			// return ResponseUtils.getSysError();
		}
	),
	http.post(PlessService.SERVICE.registAuthoritySet.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(registAuthoritySet);
			// return ResponseUtils.getSysError();
		}
	),
	http.post(PlessService.SERVICE.updateAuthoritySet.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(updateAuthoritySet);
			// return ResponseUtils.getSysError();
		}
	),
];

const getFunctionList = {
	status: "ok",
  message: "処理終了",
  result: {
    obj: {
		  FuncInfoList: [
				{
					FuncId: "KYMW11",
					FuncName: "商品マスタ",
					ShowSeq: "20",
				},
				{
					FuncId: "KYMW12",
					FuncName: "サイクル登録",
					ShowSeq: "30",
				} 
			]
    }
  }
}

const getAuthoritySetDetail = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
  		AuthoritySetId: "00",
  		AuthoritySetName: "管理者",
  		AdminDiv: "1",
      AuthoritySetExplanation: "管理者権限 有効",
			AuthorityStatus: "0",
			FuncInfoList: [
				{
					FuncId: "KYMW11",
					FuncName: "商品マスタ",
					ShowSeq: "20",
					EnableMode: "1",
				},
				{
					FuncId: "KYMW12",
					FuncName: "サイクル登録",
					ShowSeq: "30",
					EnableMode: "1",
				}, 
				{
					FuncId: "KYMW13",
					FuncName: "商品企画",
					ShowSeq: "30",
					EnableMode: "2",
				} 
			]
		}
		// obj: {
  	// 	AuthoritySetId: "00",
  	// 	AuthoritySetName: "非管理者",
  	// 	AdminDiv: "0",
    //   AuthoritySetExplanation: "管理者権限なし、無効",
		// 	AuthorityStatus: "1",
		// 	FuncInfoList: [
		// 		{
		// 			FuncId: "KYMW11",
		// 			FuncName: "商品マスタ",
		// 			ShowSeq: "20",
		// 			EnableMode: "0",
		// 		},
		// 		{
		// 			FuncId: "KYMW12",
		// 			FuncName: "サイクル登録",
		// 			ShowSeq: "30",
		// 			EnableMode: "1",
		// 		}, 
		// 		{
		// 			FuncId: "KYMW13",
		// 			FuncName: "商品企画",
		// 			ShowSeq: "30",
		// 			EnableMode: "2",
		// 		} 
		// 	]
		// }
	}
}

const registAuthoritySet = {
	status: "ok",
	message: "処理終了",
	result: {
		obj: {
			AuthoritySetId: "30"
		}
	}
}

const updateAuthoritySet = {
	status: "ok",
	message: "処理終了",
}